"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentType_1 = require("../models/type/PaymentType");
var PaymentRepository_1 = __importDefault(require("../repositories/PaymentRepository"));
var ApiConfiguration_1 = __importDefault(require("../utils/models/ApiConfiguration"));
var PaymentService = /** @class */ (function () {
    function PaymentService() {
    }
    PaymentService.pay = function (paymentType, orderId, redirectUrls) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    switch (paymentType) {
                        case PaymentType_1.PaymentType.ems:
                        case PaymentType_1.PaymentType.stripe:
                            return [2 /*return*/, PaymentRepository_1.default.pay(paymentType, orderId, this._generateBackendReturnUrls(false, redirectUrls))];
                        case PaymentType_1.PaymentType.ideal:
                        case PaymentType_1.PaymentType.mollie:
                        case PaymentType_1.PaymentType.ogone:
                        case PaymentType_1.PaymentType.paynovate:
                            return [2 /*return*/, PaymentRepository_1.default.pay(paymentType, orderId, this._generateBackendReturnUrls(true, redirectUrls))];
                        case PaymentType_1.PaymentType.adyen:
                        case PaymentType_1.PaymentType.europabank:
                            return [2 /*return*/, PaymentRepository_1.default.payOnline(paymentType, orderId, this._generateOnlinePaymentReturnUrls(redirectUrls))];
                        case PaymentType_1.PaymentType.custom:
                            throw new Error('This payment method isn\'t implemented');
                        default:
                            throw new Error('This payment method isn\'t possible');
                    }
                }
                catch (e) {
                    return [2 /*return*/, Promise.reject(e)];
                }
                return [2 /*return*/];
            });
        });
    };
    PaymentService.getPaymentStatus = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, PaymentRepository_1.default.getPaymentStatus(orderId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PaymentService._generateOnlinePaymentReturnUrls = function (redirectUrls) {
        return {
            returnUrl: redirectUrls.acceptUrl
        };
    };
    PaymentService._generateBackendReturnUrls = function (appReturn, redirectUrls) {
        if (appReturn === void 0) { appReturn = false; }
        var acceptUrl = redirectUrls.acceptUrl, declineUrl = redirectUrls.declineUrl, cancelUrl = redirectUrls.cancelUrl, exceptionUrl = redirectUrls.exceptionUrl;
        if (appReturn) {
            return {
                acceptUrl: acceptUrl,
                declineUrl: declineUrl,
                cancelUrl: cancelUrl,
                exceptionUrl: exceptionUrl
            };
        }
        return {
            acceptUrl: "".concat(ApiConfiguration_1.default.getBaseUrl(), "/return-payment-ems?scheme=").concat(acceptUrl),
            cancelUrl: "".concat(ApiConfiguration_1.default.getBaseUrl(), "/return-payment-ems?scheme=").concat(cancelUrl),
            exceptionUrl: "".concat(ApiConfiguration_1.default.getBaseUrl(), "/return-payment-ems?scheme=").concat(exceptionUrl)
        };
    };
    return PaymentService;
}());
exports.default = PaymentService;
